import { render, staticRenderFns } from "./ShopCartItem.vue?vue&type=template&id=382983e7&scoped=true&"
import script from "./ShopCartItem.vue?vue&type=script&lang=js&"
export * from "./ShopCartItem.vue?vue&type=script&lang=js&"
import style0 from "./ShopCartItem.vue?vue&type=style&index=0&id=382983e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382983e7",
  null
  
)

export default component.exports